module.exports = __webpack_public_path__ + "img/中国银行智能填单系统.5c555c71.png";